import React from "react";
import styled from "@emotion/styled";
import { TextField, Box, MenuItem,Autocomplete, InputAdornment } from "@mui/material";
import CalenderIcon from "../assets/icons/calendar-dash.svg";
import HolidayDate from "./DateSelectDialog";
import ErrorMsg from './ErrorMsg';

import { tokens } from "../theme";
const TextBox = styled(Box)({
    display: "block",
    wordBreak: "break-word",
    fontSize: "1rem",
    fontWeight: "500",
    color:tokens.pendingText,
    lineHeight:1.7,
    marginTop: "0.75rem",
});

const InputStyle = {
    fontSize: "1rem", 
    lineHeight: '1.5rem',
    backgroundColor: "#FFFCF8",
    borderRadius: "6px",
    padding: "1"
}

export const FormField = ({width,label,type,value,onChange,options}) =>{
    return(
        <Box width={width}>
            <TextBox>{label}</TextBox>
            {type==="select"?(
                    <TextField
                        select
                        id="outlined-basic"
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={value}
                        onChange={onChange}
                        sx={{
                            '& .MuiInputBase-root': InputStyle,
                            "& .MuiOutlinedInput-notchedOutline":{
                                border: "1px solid #EAD8CC",
                            }
                        }}
                        >
                        {options.map((option, index) => (
                            <MenuItem key={index} value={option}>
                            {option}
                            </MenuItem>
                        ))}
                    </TextField>
            ):(
                    <TextField
                        id="outlined-basic"
                        variant="outlined"
                        size="small"
                        fullWidth
                        value={value}
                        onChange={onChange}
                        sx={{
                        "& .MuiInputBase-root": InputStyle,
                        "& .MuiOutlinedInput-notchedOutline": {
                            border: "1px solid #EAD8CC",
                        },
                        }}
                />
            )}
        </Box>
    )
}

export const AutocompleteField =({width,label,value,onChange,options}) =>{
    return(
        <Box width={width}>
            <TextBox>{label}</TextBox>
            <Autocomplete
                  options={options}
                  size="small"
                  value={value}
                  onChange={onChange}
                  sx={{
                    '& .MuiInputBase-root': InputStyle,
                      "& .MuiOutlinedInput-notchedOutline":{
                        border: "1px solid #EAD8CC",
                      }
                  }}
                  renderInput={(params) => <TextField {...params}/>}
               />
        </Box>
    )
}

export const DateField = ({ label, value,fullwidth, isDialogOpen, openDialog, closeDialog, onSelect , disabled, validation, past}) => {
    return (
      <Box sx={{ width: fullwidth?'100%':'48%'}}>
        <TextBox>{label}</TextBox>
        <TextField
          placeholder="YYYY-MM-DD"
          value={value || ''}
          onClick={openDialog}
          variant="outlined"
          size="small"
          disabled={disabled}
          fullWidth
          // The field that failed should look like it. Without this the border
          // stayed neutral and the only sign was a line of red text below,
          // which is easy to read as a note about the form rather than about
          // this input.
          error={Boolean(validation)}
          InputProps={{
            readOnly: true,
            endAdornment: (
              <InputAdornment position="end">
                <img src={CalenderIcon} alt="Calendar" />
              </InputAdornment>
            ),
          }}
          sx={{
            "& .MuiInputBase-root": InputStyle,
            "& .MuiOutlinedInput-notchedOutline": {
                border: validation ? `1px solid ${tokens.danger}` : "1px solid #EAD8CC",
            }
          }}
        />
        <ErrorMsg>{validation}</ErrorMsg>
        <HolidayDate open={isDialogOpen} onClose={closeDialog} onSelect={onSelect} past={past}/>
      </Box>
    );
  };
  
 
  